//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import React        from 'react';
import { useState } from 'react';
import { useMemo }  from 'react';

import moment          from 'moment';
import { useSelector } from 'react-redux';

import { Api }                from '@api';
import useContextTranslator   from '@hooks/ContextTranslator';
import ConfirmModal           from '@stateless/composed/ConfirmModal';
import { selectUserContract } from '@store/selectors/user';

const PaymentPendingModal = () => {
    const [showModal, setShowModal] = useState(true);
    const userContract              = useSelector(selectUserContract);
    const onCloseModal              = () => {
        setShowModal(false);
    };
    const onConfirmClicked          = () => {
        window.open(Api.getUrl(`${userContract?.iri}/self-service`), '_blank');
    };
    const shouldShowModal           = useMemo(() => {
        return (
            showModal &&
            userContract &&
            userContract.status === 'Active' &&
            new Date(userContract.nextBillingDate) < new Date()
        );
    }, [showModal, userContract]);
    const translator                = useContextTranslator('modal');
    const nextBillingDate           = moment(userContract?.nextBillingDate);
    const contractDeletionDate      = nextBillingDate.clone();

    contractDeletionDate.add(10, 'days');

    const daysTillCancel = contractDeletionDate.diff(moment(), 'days');

    return (

        <ConfirmModal
            show={shouldShowModal}
            onClose={onCloseModal}
            onConfirm={onConfirmClicked}
            cancelButtonText={'close'}
            cancelButtonIcon={null}
            confirmButtonText={'manageContract'}
            confirmButtonIcon={null}
            title={translator.t('paymentPendingTitle')}
            text={translator.t('paymentPendingText', {
                paymentDate: nextBillingDate.format('DD.MM.YYYY'),
                daysTillCancel,
            })}
        />
    );
};

export default PaymentPendingModal;
